import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageServices from "../../services/PageServices";

function TrendWithStocks() {
  const [bullish, setBullish] = useState([]);
  const [bearish, setBearish] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [date, setDate] = useState(() => new Date().toISOString().split("T")[0]);
  const [activeTab, setActiveTab] = useState("bullish");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date) return;
    setLoading(true);
    PageServices.getTrendWithStocks(date)
      .then((response) => {
        const payload = response?.data;
        setBullish(Array.isArray(payload?.bullishWithTrend) ? payload.bullishWithTrend : []);
        setBearish(Array.isArray(payload?.bearishWithTrend) ? payload.bearishWithTrend : []);
      })
      .catch(() => {
        setBullish([]);
        setBearish([]);
      })
      .finally(() => setLoading(false));
  }, [date]);

  const filterList = (list) => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return list;
    return list.filter(
      (item) =>
        String(item.symbol || "").toLowerCase().includes(q) ||
        String(item.productId || "").toLowerCase().includes(q)
    );
  };

  const filteredBullish = useMemo(() => filterList(bullish), [bullish, searchQuery]);
  const filteredBearish = useMemo(() => filterList(bearish), [bearish, searchQuery]);

  const formatDate = (isoDate) => {
    const d = new Date(isoDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return d.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  const getFormattedTime24 = (timestamp) => {
    const d = new Date(new Date(timestamp).getTime() - 5.5 * 60 * 60 * 1000);
    return d.toTimeString().slice(0, 5);
  };

  const renderStockGrid = (list) => (
    <div className="trends-stocks stocks-outer">
      <div className="trends-stocks-inner sr-stocks-inner">
        {list.map((stock, index) => (
          <button key={`${stock.productId}-${index}`} type="button" className="stocks-box">
            <h6 style={{ color: "#fff" }}>
              {stock.symbol || stock.productId}
            </h6>
            <h5 className="time" style={{ color: "#fff" }}>
              {stock.parentTimestamp
                ? new Date(
                    new Date(stock.parentTimestamp).getTime() - 5.5 * 60 * 60 * 1000
                  ).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                : ""}
            </h5>
            <div className="flex justify-center mt-4 space-x-2">
              <button
                type="button"
                className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                onClick={() => {
                  const dateStr = formatDate(stock.parentTimestamp);
                  const timeStr = getFormattedTime24(stock.parentTimestamp);
                  const symbolToken = stock.productId;
                  localStorage.setItem("stock", symbolToken);
                  window.open(
                    `/backtester?date=${dateStr}&time=${timeStr}&symbolToken=${symbolToken}`,
                    "_blank"
                  );
                }}
              >
                Historical
              </button>
              <button
                type="button"
                className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                onClick={() => {
                  localStorage.setItem("stock", stock.productId);
                  window.open("/optionchain", "_blank");
                }}
              >
                Live Data
              </button>
            </div>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <section className="sr-stocks-section py-70">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center mb-3 px-2 flex-wrap gap-2">
          <div className="col-auto">
            <Link to="/strong-sr-stock" className="btn btn-outline-secondary btn-sm">
              ← Triple S/R Stock
            </Link>
          </div>
          <div className="col-auto text-center">
            <h4 className="mb-0">Bullish / Bearish with Trend</h4>
            <p className="small text-muted mb-0">
              PE: ≥2 of (OI, OI chg, vol) at chain max + intraday Bullish · CE: same + intraday Bearish
            </p>
          </div>
          <div className="col-auto">
            <input
              className="form-control"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>

        <ul className="nav nav-pills mb-3 justify-content-center">
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link site-btn ${activeTab === "bullish" ? "active" : ""}`}
              style={{
                backgroundColor: activeTab === "bullish" ? "green" : "",
                color: activeTab === "bullish" ? "white" : "",
              }}
              onClick={() => setActiveTab("bullish")}
            >
              Bullish with Trend
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link site-btn ${activeTab === "bearish" ? "active" : ""}`}
              style={{
                backgroundColor: activeTab === "bearish" ? "#b91c1c" : "",
                color: activeTab === "bearish" ? "white" : "",
              }}
              onClick={() => setActiveTab("bearish")}
            >
              Bearish with Trend
            </button>
          </li>
        </ul>

        <div className="searchForm text-center mb-3">
          <div className="d-inline-flex align-items-center border rounded px-2 bg-white">
            <i className="fa fa-search" />
            <input
              type="text"
              placeholder="Search symbol…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="border-0 outline-0 ms-2"
              style={{ fontSize: "16px", width: "200px" }}
            />
          </div>
        </div>

        {loading ? (
          <p className="text-center">Loading… (live intraday check per symbol may take a moment)</p>
        ) : activeTab === "bullish" ? (
          filteredBullish.length > 0 ? (
            renderStockGrid(filteredBullish)
          ) : (
            <p className="text-center">No bullish-with-trend names for this date.</p>
          )
        ) : filteredBearish.length > 0 ? (
          renderStockGrid(filteredBearish)
        ) : (
          <p className="text-center">No bearish-with-trend names for this date.</p>
        )}
      </div>
    </section>
  );
}

export default TrendWithStocks;
